module.exports = __webpack_public_path__ + "media/images/success-img/layer-6-a2e3c9279666e2851d075ceb4622db7f.png";